/**
 * 重复点展示效果辅助类
 * Created by 1 on 2016/12/14.
 */
'use strict';
define([
    '../utils/CommonUtil',
    '../utils/GeometryUtil',
    './DistanceGrid',
    '../g2',
],function(
    CommonUtil,
    GeometryUtil,
    DistanceGrid,
    g2
){
   var helper={};
   //初始化图层
   helper.init=function(){
        //距离格网
       this.distanceGrid=new DistanceGrid(this.options.spiderfyDistance);
       if(this.options.showSpiderLeg){
           //重复点自动排列的附加图层
           this.spiderfyAttachLayer=new g2.carto.ElementLayer({
               id:this.options.layerId+'-spiderfyattach',
               name:this.options.layerName+'重复点自动排列的辅助图层',
               map: this.map
           });
           this.map.addLayer(this.spiderfyAttachLayer);
       }
       if(this.options.enableCoincidenceCluster){//允许重复点聚合
           //重复点自动排列的附加图层
           this.coincidenceClusterLayer=new g2.carto.ElementLayer({
               id:this.options.layerId+'-coincidence-cluster',
               name:this.options.layerName+'重复点聚合图层',
               map: this.map
           });
           this.map.addLayer(this.coincidenceClusterLayer);
           //重复点自动排列的滑过展开图层
           this.coincidenceHoverLayer=new g2.carto.ElementLayer({
               id:this.options.layerId+'-coincidence-hover',
               name:this.options.layerName+'重复点滑过展开',
               map: this.map
           });
           this.map.addLayer(this.coincidenceHoverLayer);
       }
       /**
        * 连线的符号
        */
       if(this.options.spiderfyLegSym){
           this.options.spiderfyLegSym=
               new g2.sfs.SimpleLineSymbol({
                   "style":this.options.spiderfyLegSym.style,
                   "width":this.options.spiderfyLegSym.width,
                   "color":this._getColor(this.options.spiderfyLegSym.color)
               });
       }
       //当前点中的重复点聚合图标
       this.currentClusterObj=null;
   };
   helper.include=function(clazz){
       var prototype=clazz.prototype;
       var includeProperties={
           /**
            * 一定级别下自动排列重复点；
            * @method
            * @param {Number} oldLevel - 必填，地图缩放级别(前)
            * @param {Number} level - 必填，地图缩放级别(后)
            */
           _applySpiderfy:function(oldLevel,level){
               if(oldLevel===level){//比例尺无变化，不处理；
                   return false;
               }
               if(!this.options.enalbeSpiderfy){
                   return false;
               }
               //是否可见
               if(!this.getVisible()){
                   return false;
               }
               var spiderfyLevel=this.options.spiderfyLevel,
                   spiderfyDistance=this.options.spiderfyDistance,
                   spiderfyFlag=false;
               //如果自动排布允许重复点聚合
               if(this.options.enableCoincidenceCluster){
                   if(level>=spiderfyLevel){
                       spiderfyFlag='spiderfy';
                   }else{
                       if(CommonUtil.assertWithin(
                               level,this.options.enableCoincidenceClusterLevel)){
                           spiderfyFlag='cluster';
                       }else{
                           this._disableSpiderfy();
                       }
                   }
               }else{
                   if(level>=spiderfyLevel){
                       spiderfyFlag='spiderfy';
                   }else if(oldLevel>=spiderfyLevel&&level<spiderfyLevel){
                       //从自动排布级别或以上级别 缩放到spiderfyLevel级别以下时；
                       this._disableSpiderfy();
                   }
               }
               console.log(spiderfyFlag);
               if(spiderfyFlag){
                   this._updateSpiderfy(spiderfyFlag);
               }
               return true;
           },
           /**
            * 更新自动排列的显示
            * @param spiderfyFlag :spiderfy=自动排布  cluster=聚合
            * @private
            */
           _updateSpiderfy:function(spiderfyFlag){
               if(!(spiderfyFlag==='spiderfy'||spiderfyFlag==='cluster')){
                   return;
               }
               //清空图层 清空格网
               this._clearSpiderfy(false);
               //
               this.layer.clear();
               //
               var self=this,spatialReference=this.options.spatialReference,
                   spiderfyThreshold=this.options.spiderfyThreshold||5;
               //加载格网数据
               for(var i=0,len=this.elements.length;i<len;i++){
                   var ele=this.elements[i],geom=ele.geometry;
                   var px=this.map.getPixelFromCoordinate([geom.x,geom.y]);
                   this.distanceGrid.addObject(ele,{x:px[0],y:px[1]});
               }
               switch(spiderfyFlag){
                   case 'spiderfy':{
                       this.distanceGrid.eachCell(function(eles,line,row){
                           if(eles.length<2){
                               self.layer.addElements(eles);
                               return;
                           }
                           //中心点
                           var coords=self._getElementsCenter(eles);
                           //添加中心点图标
                           var centerGeom=new g2.sfs.Point({x:coords[0],y: coords[1],spatialReference: spatialReference});
                           //
                           var len=eles.length,arr,showLeg=self.options.showSpiderLeg,
                               centerPixel=self.map.getPixelFromCoordinate(coords);
                           if(len<=spiderfyThreshold){
                               var circleRaidus=self.options.circleRadius||20;
                               arr=GeometryUtil.getCirclePonits({
                                   center:centerPixel,
                                   radius:circleRaidus,
                                   count:len});
                           }else{
                               arr=GeometryUtil.getSpiderfy(centerPixel,len,11,5,28);
                           }
                           for(var k=0;k<len;k++){
                               try{
                                   var el=eles[k];
                                   var pp=self.map.getCoordinateFromPixel(arr[k]),
                                       ppoint=new g2.sfs.Point({x:pp[0],y: pp[1],spatialReference: spatialReference});
                                   var ee=new g2.sfs.Element({
                                       id:el.id,
                                       geometry: ppoint,
                                       symbol: el.symbol
                                   });
                                   ee._data=el._data;
                                   self.layer.add(ee);
                                   if(showLeg){//显示连线
                                       //add legs
                                       var legGeom = new g2.sfs.Polyline({spatialReference: spatialReference});
                                       var path=new g2.sfs.Path({spatialReference:spatialReference});
                                       path.addPoint(centerGeom);
                                       path.addPoint(ppoint);
                                       legGeom.addGeometry(path);
                                       var legSym=self.options.spiderfyLegSym;
                                       var legElement=new g2.sfs.Element({
                                           geometry: legGeom,
                                           symbol: legSym
                                       });
                                       self.spiderfyAttachLayer.add(legElement);
                                   }
                               }catch(e){
                               }
                           }
                       });
                       break;
                   }
                   case 'cluster':{
                       this.distanceGrid.eachCell(function(eles,line,row){
                           if(eles.length<2){
                               self.layer.addElements(eles);
                           }else{
                               //中心点
                               var coords=self._getElementsCenter(eles);
                               //添加中心点图标
                               var centerGeom=new g2.sfs.Point({x:coords[0],y: coords[1],
                                   spatialReference: spatialReference});
                               var clusterSym=self.getCoincidenceClusterSym(eles);
                               var clusterId=line+'_'+row;
                               var clusterEle=new g2.sfs.Element({
                                   id:clusterId,
                                   geometry: centerGeom,
                                   symbol: clusterSym
                               });
                               //引用元素的行列号
                               clusterEle._indexs=[line,row];
                               self.coincidenceClusterLayer.add(clusterEle);
                           }
                       });
                       break;
                   }
               }
           },
           /**
            * 添加滑过展开效果
            * @param element
            * @private
            */
           _addHoverSpiderfy:function(element){
               var indexs=element._indexs;//根据行列号获取
               if(!(indexs&&indexs.length==2)){
                   return false;
               }
               var eles=this.distanceGrid.getObjects(indexs[0],indexs[1]),
                   spatialReference=this.options.spatialReference;
               /**
                * 如果个数超过限制，则不显示展开效果
                */
               if(eles.length>this.options.coincidenceClusterHoverThreshold){
                   return false;
               }
               //中心点
               var coords=this._getElementsCenter(eles);
               //添加中心点图标
               var centerGeom=new g2.sfs.Point({x:coords[0],y: coords[1],
                   spatialReference: spatialReference});
               var len=eles.length,arr,showLeg=this.options.showSpiderLeg,
                   legSym=this.options.spiderfyLegSym,
                   centerPixel=this.map.getPixelFromCoordinate(coords),
                   spiderfyThreshold=this.options.spiderfyThreshold||5;
               if(len<=spiderfyThreshold){
                   var circleRaidus=this.options.circleRadius||20;
                   arr=GeometryUtil.getCirclePonits({
                       center:centerPixel,
                       radius:circleRaidus,
                       count:len});
               }else{
                   arr=GeometryUtil.getSpiderfy(centerPixel,len,11,5,28);
               }
               for(var i=0;i<len;i++){
                   var ele=eles[i];
                   var pp=this.map.getCoordinateFromPixel(arr[i]);
                   var ppoint=new g2.sfs.Point({x:pp[0],y: pp[1],spatialReference: spatialReference});
                   var legGeom = new g2.sfs.Polyline({spatialReference: spatialReference});
                   var path=new g2.sfs.Path({spatialReference:spatialReference});
                   path.addPoint(centerGeom);
                   path.addPoint(ppoint);
                   if(showLeg){
                       legGeom.addGeometry(path);
                       var legSym=this.options.spiderfyLegSym;
                       var legElement=new g2.sfs.Element({
                           geometry: legGeom,
                           symbol: legSym
                       });
                       this.coincidenceHoverLayer.add(legElement);
                   }
                   var ee=new g2.sfs.Element({
                       id:ele.id,
                       geometry: ppoint,
                       symbol: ele.symbol
                   });
                   this.coincidenceHoverLayer.add(ee);
               }
               return true;
           },
           /**
            * 获取符合样式
            * @method
            * @memberOf G.lys.PointLayer.prototype
            * @param {Array} elements - 必填，样式集合
            * @returns {g2.sfs.CurrencySymbol}
            */
           getCoincidenceClusterSym:function(elements){
               elements=elements||[];
               var len=elements.length,
                   markerSym=this.options.coincidenceClusterMarkerSym||{},
                   textSym=this.options.coincidenceClusterTextSym||{};
               var text=len+'';
               //
               if(markerSym.borderColor){
                   markerSym.borderColor=this._getColor(markerSym.borderColor);
               }
               if(markerSym.fillColor){
                   markerSym.fillColor=this._getColor(markerSym.fillColor);
               }
               if(textSym.foreground){
                   textSym.foreground=this._getColor(textSym.foreground);
               }
               if(textSym.borderColor){
                   textSym.borderColor=this._getColor(textSym.borderColor);
               }
               //
               var fontSize=textSym.fontSize||15;
               var minSize=fontSize*this.options.coincidenceClusterWeight,offsetX= 0, offsetY=0;
               var size=CommonUtil.getEquivalentNum(text,minSize,minSize);
               var markerDefaultSym={
                   borderColor: new g2.sfs.Color({a: 150, r: 50, g: 175, b: 254}),
                   fillColor: new g2.sfs.Color({a: 220, r: 4, g: 131, b: 232}),
                   borderThickness: size,
                   size:size
               },textDefaultSym={
                   text:text,
                   fontSize:fontSize,
                   fontWeight:1,
                   offsetX:offsetX,   //横向偏移正值向右 负值向左
                   offsetY:offsetY,  //纵向偏移正值向下 负值向上
                   foreground: new g2.sfs.Color({a: 255, r: 255, g: 255, b: 255}),
                   borderColor:new g2.sfs.Color({a: 1, r: 255, g: 255, b: 255}),
                   borderThickness:0
               };
               jQuery.extend(true,markerDefaultSym,markerSym);
               jQuery.extend(true,textDefaultSym,textSym);
               //点符号
               var markerSymbol = new g2.sfs.SimpleMarkerSymbol(markerDefaultSym);

               //文本符号  如果没有offsetX和offsetY文字在中间显示
               var textSymbol=new g2.sfs.TextSymbol(textDefaultSym);
               //复合符号
               var currencySymbol = new g2.sfs.CurrencySymbol({
                   markerSymbol:markerSymbol,
                   textSymbol:textSymbol
               });
               return currencySymbol;
           },
           /**
            * 清除
            * @private
            * @param flag true从地图移除
            */
           _clearSpiderfy:function(flag){
               if(this.options.enalbeSpiderfy){
                   if(this.spiderfyAttachLayer){
                       this.spiderfyAttachLayer.clear();
                       if(flag){
                           this.map.removeLayer(this.spiderfyAttachLayer);
                       }
                   }
                   if(this.coincidenceClusterLayer){
                       var eles=this.coincidenceClusterLayer.elements;
                       for(var k in eles){
                           var ele=eles[k];
                           if(ele){
                               //清除引用
                               ele._indexs=null;
                               delete ele._indexs;
                           }
                       }
                       this.coincidenceClusterLayer.clear();
                       if(flag){
                           this.map.removeLayer(this.coincidenceClusterLayer);
                       }
                   }
                   if(this.coincidenceHoverLayer){
                       this.coincidenceHoverLayer.clear();
                       if(flag){
                           this.map.removeLayer(this.coincidenceHoverLayer);
                       }
                   }
                   if(this.distanceGrid){
                       if(flag){
                           this.distanceGrid.destroy();
                       }else{
                           this.distanceGrid.clear();
                       }
                   }
               }
           },
           /**
            * 取消自动排列
            * @private
            */
           _disableSpiderfy:function(){
               this.layer.clear();
               this.layer.addElements(this.elements);
               this._clearSpiderfy();
           },
           /**
            * 切换当前点中的聚合图标的显示
            * @param visible
            * @private
            */
           _toggleCurrentClusterElement:function(visible){
               if(this.currentClusterObj==null){
                   return;
               }
               var element=this.coincidenceClusterLayer.find(
                   this.currentClusterObj.id
               );
               if(visible===true){
                   this.coincidenceClusterLayer.showElement(element,true);
                   this.currentClusterObj=null;
               }else{
                   this.coincidenceClusterLayer.showElement(
                       element,false
                   );
               }
           },
           /**
            * 判断是否需要重新显示隐藏的聚合元素
            * @private
            * @param element
            */
           _applyToggleCurrentClusterElement:function(element){
               var flag=true;
               if(this.currentClusterObj!=null){
                   var clusterElement=this.coincidenceClusterLayer.find(
                       this.currentClusterObj.id);
                   var indexs=clusterElement._indexs;//如果点击的是聚合展开的分布元素，则不切换显示
                   var elementList=this.distanceGrid.getObjects(indexs[0],indexs[1]);
                   for(var i=0;i<elementList.length;i++){
                       if(element.id===elementList[i].id){
                           flag=false;
                           break;
                       }
                   }
               }
               return flag;
           },
           //提取聚合的元素信息
           _extractClusterElement:function(element){
                if(element){
                    var obj={};
                    obj.id=element.id;
                    obj.elementSet={};
                    var indexs=element._indexs;
                    var elementList=this.distanceGrid.getObjects(indexs[0],indexs[1]);
                    for(var i=0;i<elementList.length;i++){
                        var eleItem=elementList[i],
                            hoverEle=this.coincidenceHoverLayer.find(eleItem.id);
                        if(hoverEle){
                            obj.elementSet[eleItem.id]={
                                x:hoverEle.geometry.x,
                                y:hoverEle.geometry.y
                            };
                        }else{
                            obj.elementSet[eleItem.id]={};
                        }
                    }
                    return obj;
                }else{
                    return null;
                }
           },
           //重新生成后获取聚合元素
           _getCurrentClusterElementIdOnUpdate:function(){
                var elementId=null;
                if(this.currentClusterObj!=null){
                    var elementSet=this.currentClusterObj.elementSet;
                    var clusterEleId=null;
                    this.distanceGrid.eachCell(function(eles,line,row){
                        var count=Object.keys(elementSet).length,
                            matchCount=0,
                            cellCount=eles.length;
                        for(var eleId in elementSet){
                            for(var i=0;i<cellCount;i++){
                                if(eles[i]&&eles[i].id===eleId){
                                    matchCount++;
                                    break;
                                }
                            }
                        }
                        if(matchCount>Math.round(count/2)){
                            clusterEleId=line+'_'+row;
                        }
                    });
                    elementId=clusterEleId||null;
                }
                return elementId;
           }
       }
       for(var k in includeProperties){
           prototype[k]=includeProperties[k];
       }
   }
    return helper;
});
